import type Owner from '@ember/owner'
import type ApplicationService from 'customer-flows/services/application'
import EventTrackerService from 'customer-flows/services/event-tracker'
import DemoEventTrackerService from 'customer-flows/demo/services/event-tracker'

export function initialize(owner: Owner): void {
  owner.register('service:event-tracker', {
    create(injections: object) {
      const application = owner.lookup('service:application') as ApplicationService
      const Implementation = application.isDemoMode ? DemoEventTrackerService : EventTrackerService
      return Implementation.create(injections)
    }
  })
}

export default {
  name: 'demo-mode',
  initialize
}
